import { Outlet } from 'react-router';
import useAuth from '../hook/useAuth';
import Loading from '../components/loading';

const LoginLayout = () => {
  const { user, signIn, signOut, loading } = useAuth();

  return loading ? (
    <div className='flex items-center justify-center min-h-dvh bg-primary'>
      <div className='flex flex-col items-center space-y-4'>
        <Loading />
        <div className={`text-lg font-medium text-white`}>Loading...</div>
      </div>
    </div>
  ) : (
    <div className='max-w-lg mx-auto'>
      <Outlet context={{ user, signIn, signOut }} />
    </div>
  );
};

export default LoginLayout;
